import React from "react";
import { Link } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import { Popup } from "semantic-ui-react";
import "./styles/cards.scss";

const limit = 12;
const highLimit = 20;

export const CardImportaciones = (props) => {
  let { element } = props;

  return (
    <>
      <Card className="_clickCard mySearchCard" id={Math.random()}>
        <CardBody>
          <div className="row">
            <div className="container-fluid">
              <div className="row">
                {/* Icono & DO ID & Estatus */}
                <div className="col-md-3">
                  <div className="row text-center">
                    {/* ==========================ICONO===================================== */}
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col">
                          <div className="mb-mail-meta">
                            <div className="mb-mail-from">
                              <span
                                style={{ fontSize: "12px", fontWeight: "bold" }}
                              >
                                {element.EsDTA === "0" ? "IMPO" : "DTA"}
                              </span>
                            </div>
                            <div className="mb-mail-subject">
                              <em
                                className={
                                  "fa-2x mr-2 fas fa-arrow-alt-circle-right"
                                }
                                style={{
                                  color: "rgb(0, 20, 137)",
                                  marginLeft: "11px",
                                }}
                              ></em>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* ==========================cliente =========================================== */}
                    <div className="col-md-4">
                      <div className="mb-mail-meta">
                        <div className="mb-mail-subject">
                          <center>
                            <span
                              style={{ fontSize: "12px", fontWeight: "bold" }}
                            >
                              Cliente
                            </span>
                          </center>
                        </div>
                        <div className="mb-mail-from">
                          <center>
                            <span style={{ fontSize: "12px" }}>
                              {element.Cliente ? (
                                element.Cliente.length > limit ? (
                                  <Popup
                                    content={element.Cliente}
                                    key={element.Cliente}
                                    position=""
                                    trigger={
                                      <span>
                                        {element.Cliente.substring(
                                          0,
                                          limit - 3
                                        )}
                                        ...
                                      </span>
                                    }
                                  />
                                ) : (
                                  element.Cliente
                                )
                              ) : (
                                ""
                              )}
                            </span>
                          </center>
                        </div>
                      </div>
                    </div>
                    {/* ==========================No. de DO===================================== */}
                    <div className="col-md-4">
                      <div className="mb-mail-meta">
                        <div className="mb-mail-subject">
                          <center>
                            <span
                              style={{ fontSize: "12px", fontWeight: "bold" }}
                            >
                              No. de DO
                            </span>
                          </center>
                        </div>
                        <div className="mb-mail-from">
                          <center>
                            <span style={{ fontSize: "12px" }}>
                              <Link
                                to={
                                  "/custom-detail-view/" + element.ImportacionId
                                }
                              >
                                {element.DOAduanaImpo ? (
                                  element.DOAduanaImpo.length > limit ? (
                                    <Popup
                                      content={element.DOAduanaImpo}
                                      key={element.DOAduanaImpo}
                                      position=""
                                      trigger={
                                        <span>
                                          {element.DOAduanaImpo.substring(
                                            0,
                                            limit - 3
                                          )}
                                          ...
                                        </span>
                                      }
                                    />
                                  ) : (
                                    element.DOAduanaImpo
                                  )
                                ) : (
                                  ""
                                )}
                              </Link>
                            </span>
                          </center>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* MODO transporte & doc transporte */}
                <div className="col-md-3">
                  <div className="row text-center">
                    {/* ==========================Estatus===================================== */}
                    <div className="col-md-4">
                      <div className="mb-mail-meta">
                        <div className="mb-mail-subject">
                          <center>
                            <span
                              style={{ fontSize: "12px", fontWeight: "bold" }}
                            >
                              <span>Estatus </span>
                            </span>
                          </center>
                        </div>
                        <div className="mb-mail-from">
                          <span style={{ fontSize: "12px" }}>
                            {element.Estatus ? (
                              element.Estatus.length > limit ? (
                                <Popup
                                  content={element.Estatus}
                                  key={element.Estatus}
                                  position=""
                                  trigger={
                                    <span>
                                      {element.Estatus.substring(0, limit - 3)}
                                      ...
                                    </span>
                                  }
                                />
                              ) : (
                                element.Estatus
                              )
                            ) : (
                              ""
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    {/* ==========================DOC transporte===================================== */}
                    <div className="col-md-4">
                      <div className="mb-mail-meta">
                        <div className="mb-mail-subject">
                          <center>
                            <span
                              style={{ fontSize: "12px", fontWeight: "bold" }}
                            >
                              Doc. de Transporte
                            </span>
                          </center>
                        </div>
                        <div className="mb-mail-from">
                          <center>
                            <span style={{ fontSize: "12px" }}>
                              {element.DocTransporte ? (
                                element.DocTransporte.length > limit ? (
                                  <Popup
                                    content={element.DocTransporte}
                                    key={element.DocTransporte}
                                    position=""
                                    trigger={
                                      <span>
                                        {element.DocTransporte.substring(
                                          0,
                                          limit - 3
                                        )}
                                        ...
                                      </span>
                                    }
                                  />
                                ) : (
                                  element.DocTransporte
                                )
                              ) : (
                                ""
                              )}
                            </span>
                          </center>
                        </div>
                      </div>
                    </div>
                    {/* ==========================ref cliente===================================== */}
                    <div className="col-md-4">
                      <div className="mb-mail-meta">
                        <div className="mb-mail-subject">
                          <center>
                            <span
                              style={{ fontSize: "12px", fontWeight: "bold" }}
                            >
                              Referencia de Cliente
                            </span>
                          </center>
                        </div>
                        <div className="mb-mail-from">
                          <center>
                            <span style={{ fontSize: "12px" }}>
                              {element.RefCliente ? (
                                element.RefCliente.length > limit ? (
                                  <Popup
                                    content={element.RefCliente}
                                    key={element.RefCliente}
                                    position=""
                                    trigger={
                                      <span>
                                        {element.RefCliente.substring(
                                          0,
                                          limit - 3
                                        )}
                                        ...
                                      </span>
                                    }
                                  />
                                ) : (
                                  element.RefCliente
                                )
                              ) : (
                                ""
                              )}
                            </span>
                          </center>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Aduana & País origen*/}
                <div className="col-md-2">
                  <div className="row text-center">
                    {/* ==========================Aduana ===================================== */}
                    <div className="col-md-5">
                      <div className="mb-mail-meta">
                        <div className="mb-mail-subject">
                          <center>
                            <span
                              style={{ fontSize: "12px", fontWeight: "bold" }}
                            >
                              Aduana
                            </span>
                          </center>
                        </div>
                        <div className="mb-mail-from">
                          <center>
                            <span style={{ fontSize: "12px" }}>
                              {element.Aduana ? (
                                element.Aduana.length > limit ? (
                                  <Popup
                                    content={element.Aduana}
                                    key={element.Aduana}
                                    position=""
                                    trigger={
                                      <span>
                                        {element.Aduana.substring(0, limit - 3)}
                                        ...
                                      </span>
                                    }
                                  />
                                ) : (
                                  element.Aduana
                                )
                              ) : (
                                ""
                              )}
                            </span>
                          </center>
                        </div>
                      </div>
                    </div>
                    {/* ==========================Pais Origen===================================== */}
                    <div className="col-md-7">
                      <div className="mb-mail-meta">
                        <div className="mb-mail-subject">
                          <center>
                            <span
                              style={{ fontSize: "12px", fontWeight: "bold" }}
                            >
                              Origen
                            </span>
                          </center>
                        </div>
                        <div className="mb-mail-from">
                          <center>
                            <span style={{ fontSize: "12px" }}>
                              {element.PuertoOrigen ? (
                                element.PuertoOrigen.length > limit ? (
                                  <Popup
                                    content={element.PuertoOrigen}
                                    key={element.PuertoOrigen}
                                    position=""
                                    trigger={
                                      <span>
                                        {element.PuertoOrigen.substring(
                                          0,
                                          limit - 3
                                        )}
                                        ...
                                      </span>
                                    }
                                  />
                                ) : (
                                  element.PuertoOrigen
                                )
                              ) : (
                                ""
                              )}
                            </span>
                          </center>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Instruccion & ATA */}
                <div className="col-md-4">
                  <div className="row text-center">
                    {/* ========================== Instruccion===================================== */}
                    <div className="col-md-4">
                      <div className="mb-mail-meta">
                        <div className="mb-mail-subject">
                          <center>
                            <span
                              style={{ fontSize: "12px", fontWeight: "bold" }}
                            >
                              Instrucción
                            </span>
                          </center>
                        </div>
                        <div className="mb-mail-from">
                          <center>
                            <span style={{ fontSize: "12px" }}>
                              {element.FechaInstruccionClienteAA ? (
                                element.FechaInstruccionClienteAA.length >
                                limit ? (
                                  <Popup
                                    content={element.FechaInstruccionClienteAA}
                                    key={element.FechaInstruccionClienteAA}
                                    position=""
                                    trigger={
                                      <span>
                                        {element.FechaInstruccionClienteAA.substring(
                                          0,
                                          limit - 3
                                        )}
                                        ...
                                      </span>
                                    }
                                  />
                                ) : (
                                  element.FechaInstruccionClienteAA
                                )
                              ) : (
                                ""
                              )}
                            </span>
                          </center>
                        </div>
                      </div>
                    </div>
                    {/* ========================== ATA ===================================== */}
                    <div className="col-md-4">
                      <div className="mb-mail-meta">
                        <div className="mb-mail-subject">
                          <center>
                            <span
                              style={{ fontSize: "12px", fontWeight: "bold" }}
                            >
                              ATA
                            </span>
                          </center>
                        </div>
                        <div className="mb-mail-from">
                          <center>
                            <span style={{ fontSize: "12px" }}>
                              {element.ATA ? (
                                element.ATA.length > limit ? (
                                  <Popup
                                    content={element.ATA}
                                    key={element.ATA}
                                    position=""
                                    trigger={
                                      <span>
                                        {element.ATA.substring(0, limit - 3)}
                                        ...
                                      </span>
                                    }
                                  />
                                ) : (
                                  element.ATA
                                )
                              ) : (
                                ""
                              )}
                            </span>
                          </center>
                        </div>
                      </div>
                    </div>
                    {/* ========================== LEVANTE ===================================== */}
                    <div className="col-md-4">
                      <div className="mb-mail-meta">
                        <div className="mb-mail-subject">
                          <center>
                            <span
                              style={{ fontSize: "12px", fontWeight: "bold" }}
                            >
                              Levante
                            </span>
                          </center>
                        </div>
                        <div className="mb-mail-from">
                          <center>
                            <span style={{ fontSize: "12px" }}>
                              {element.FechaLevante ? (
                                element.FechaLevante.length > limit ? (
                                  <Popup
                                    content={element.FechaLevante}
                                    key={element.FechaLevante}
                                    position=""
                                    trigger={
                                      <span>
                                        {element.FechaLevante.substring(
                                          0,
                                          limit - 3
                                        )}
                                        ...
                                      </span>
                                    }
                                  />
                                ) : (
                                  element.FechaLevante
                                )
                              ) : (
                                ""
                              )}
                            </span>
                          </center>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* END OF MAIN DIV */}
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </>
  );
};
